export default __webpack_public_path__ + "static/media/pman.c13ede7b.png";